class User {
    id?: number;
    email?: string;
    dni: string;
    password: string;
    father_lastname?: string;
    mother_lastname?: string;
    first_name?: string;
    second_name?: string;

    constructor({ id, email, dni, password, father_lastname, mother_lastname, first_name, second_name }: {
        email?: string,
        dni: string,
        password: string,
        id?: number,
        father_lastname?: string,
        mother_lastname?: string,
        first_name?: string,
        second_name?: string
    }) {
        this.email = email;
        this.dni = dni;
        this.password = password;
        this.father_lastname = father_lastname === "null" ? "" : father_lastname;
        this.mother_lastname = mother_lastname === "null" ? "" : mother_lastname;
        this.first_name = first_name === "null" ? "" : first_name;
        this.second_name = second_name === "null" ? "" : second_name;

        if (id) {
            this.id = id;
        }
    }

    // Método para validar que los campos no estén vacíos
    validateFields(): boolean {
        if (!this.email || !this.dni || !this.password) {
            console.error('Todos los campos son obligatorios');
            return false;
        }
        return true;
    }

    validateLoginFields(): boolean {
        if (!this.dni || !this.password) {
            console.error('Todos los campos son obligatorios');
            return false;
        }
        return true;
    }

    // Método para imprimir información del usuario (puedes cambiarlo según tus necesidades)
    printUserInfo(): void {
        console.log(`ID: ${this.id}, Email: ${this.email}, DNI: ${this.dni}`);
    }
}

export default User;
